import styles from './index.module.css';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import DOMPurify from 'dompurify';
import { useEffect, useRef } from 'react';
gsap.registerPlugin(ScrollTrigger);
const MainPoint = ({ textData ,language}) => {
  const text1Ref = useRef(null);
  const text2Ref = useRef(null);
  const text3Ref = useRef(null);
  const text4Ref = useRef(null);
  const ctnRef = useRef(null);
  const videoRef = useRef(null);
  const textBoxRef = useRef(null);
  useEffect(() => {
    gsap.to(text1Ref.current, {
      opacity: 1,
      scrollTrigger: {
        trigger: text1Ref.current,
        start: 'top 80%',
        end: 'center center',
        scrub: 1,
      },
    });
  }, []);
  useEffect(() => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: textBoxRef.current,
        start: 'top center',
        end: '+=200%',
        scrub: 1,
      },
    });

    tl.to(
      textBoxRef.current,
      {
        yPercent: -100,
        duration: 3,
      },
      0,
    );

    tl.to(
      text2Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      0,
    );
    tl.to(
      text3Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      0.5,
    );
    tl.to(
      text4Ref.current,
      {
        opacity: 1,
        duration: 1,
      },
      1,
    );
  }, []);

  useEffect(() => {
    ScrollTrigger.create({
      trigger: ctnRef.current,
      start: 'top top',
      // end: '+=100%',
      pin: true,
      pinSpacing: true,
      scrub: 1,
    });
  }, []);
  return (
    <div className={styles.ctn} ref={ctnRef}>
      <video
        autoPlay
        loop
        playsInline
        muted
        preload="true"
        src={`https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-summary${language === 'cn' ? '' : '-en'}.mp4`}
        poster={`https://bucket.zhiyun-tech.com/detail/fiveraym40/fiveraym40-video-summary-cover${language === 'cn' ? '' : '-en'}.jpg`}
        ref={videoRef}
      ></video>
      <div className={styles.textBox} ref={textBoxRef}>
        <h2
          ref={text1Ref}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text3']),
          }}
        ></h2>
        <h2
          ref={text2Ref}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text4']),
          }}
        ></h2>
        <h2
          ref={text3Ref}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text5']),
          }}
        ></h2>
        <h2
          ref={text4Ref}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text6']),
          }}
        ></h2>
      </div>
    </div>
  );
};

export default MainPoint;
